import {createDatatableColumnRegistry} from "@/src/modules/core/lib/datatable-columns";

export const INCIDENT_TABLE_COLUMN_IDS = [
  "created_at",
  "incident_date",
  "type",
  "reported_by",
  "details",
] as const;

export type IncidentTableColumnId = (typeof INCIDENT_TABLE_COLUMN_IDS)[number];

const COLUMN_DEFS = [
  {id: "created_at", label: "Created At", defaultVisible: true},
  {id: "incident_date", label: "Incident Date", defaultVisible: true},
  {id: "type", label: "Type", defaultVisible: true},
  {id: "reported_by", label: "Reported by", defaultVisible: true},
  {id: "details", label: "Details", defaultVisible: true},
] as const;

export const incidentsTableColumns = createDatatableColumnRegistry(
  INCIDENT_TABLE_COLUMN_IDS,
  COLUMN_DEFS,
);

export const getIncidentTableColumnDef = incidentsTableColumns.getColumnDef;
export const getOrderedVisibleIncidentColumns = incidentsTableColumns.getOrderedVisibleColumns;
